import type { RecipeSummary } from '@/api/types'
import { Badge, EffortBadge, RatingStars, VegetarianBadge } from '@/components/ui/Badge'
import { CuisineDot } from '@/components/ui/CuisineAccent'
import { TagChip } from '@/components/ui/TagChip'
import { cn } from '@/lib/cn'

/** The at-a-glance row: cuisine, protein, veg, rating, effort and tags. */
export function RecipeFacts({
  recipe,
  tags = false,
  className,
}: {
  recipe: RecipeSummary
  tags?: boolean
  className?: string
}) {
  const identity = [recipe.cuisine, recipe.protein_base].filter(Boolean).join(' · ')
  return (
    <div className={cn('flex flex-wrap items-center gap-x-3 gap-y-1.5 text-sm', className)}>
      {identity ? (
        <span className="inline-flex min-w-0 items-center gap-1.5 text-ink-soft">
          <CuisineDot cuisine={recipe.cuisine} />
          <span className="truncate">{identity}</span>
        </span>
      ) : null}
      <VegetarianBadge vegetarian={recipe.vegetarian} />
      {recipe.excluded ? <Badge tone="critical">Excluded</Badge> : null}
      <RatingStars value={recipe.rating} />
      <EffortBadge level={recipe.effort_level} />
      {tags ? recipe.tags.map((tag) => <TagChip key={tag} tag={tag} />) : null}
    </div>
  )
}
